import { Autocomplete, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { formStyle } from '../../contractStyles';

FormAutocomplete.propTypes = {
    fieldName: PropTypes.string,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    readOnlyValue: PropTypes.string,
};

export default function FormAutocomplete({ fieldName, placeholder, required, options, disabled = false, readOnlyValue = null }) {
    const { control } = useFormContext();

    return (disabled ?
        <Controller
            name={fieldName}
            control={control}
            render={({ field }) => (
                <TextField
                    disabled
                    fullWidth
                    size="small"
                    value={
                        readOnlyValue ||
                        options?.find(o => o.value === field.value)?.label ||
                        ''
                    }
                    sx={formStyle}
                    autoComplete="off"
                />
            )}
        />
        :
        <Controller
            name={fieldName}
            control={control}
            rules={{ validate: (value) => required && !value ? `This field is required` : true, }}
            render={({ field, fieldState }) =>
                <Autocomplete
                    key={field.id}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') e.preventDefault();
                    }}
                    options={options ?? []}
                    getOptionLabel={(opt) => opt?.label || ''}
                    value={options?.find((opt) => opt.value === field.value) || null}
                    disabled={disabled}
                    onChange={(_, value) => field.onChange(value ? value.value : null)}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    renderInput={(paramsInput) => (
                        <TextField
                            {...paramsInput}
                            inputRef={field.ref}
                            fullWidth
                            size="small"
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            sx={formStyle}
                            autoComplete="off"
                            placeholder={placeholder}
                        />
                    )}
                />
            }
        />
    );
}
